export const SCHEDULE_TYPES = {
	PRE_APPOINTMENT: 1,
	URGENT_APPOINTMENT: 2,
}